@if (showMiniGame) {
	<app-find-a-pair
		(finishGame)="closeMiniGame($event)"
	></app-find-a-pair>
} @else if (showCards) {
	<app-backgrop>
  <div class="flex flex-col justify-center items-center  overflow-x-auto no-scrollbar landscape:overflow-auto relative top-5 md:top-0">
    <div class="overflow-x-auto w-full px-4 no-scrollbar">
      <div class="flex gap-4 md:gap-8 h-[550px] items-center justify-start w-max card-container" [class.m-auto]="selected">
				@if (selected) {
						<app-flip-card
							class="w-[320px] h-[500px]  md:w-[350px] max-w-full cardContainer" [class.cardContainerShow]="isShow"
							[class.md:scale-100]="!selected.opened"
							[class.md:scale-105]="selected.opened"
							[title]="selected.subtitle!"
							[resultData]="selected.resultData"
							[imgSrc]="selected.resultImg"
							[color]="selected.color"
							[isOpen]="!!selected.opened"
							[isRowItem]="true"
							(opened)="playClick();openCard()"
						/>

				} @else {
					@for (item of cards; track $index) {
						<app-flip-card
							(click)="selectCard(item)"
							class="w-[320px] h-[500px] max-w-full"
							[class.md:scale-100]="!item.opened"
							[class.md:scale-105]="item.opened"
							[shouldOpen]="false"
							[title]="item.title"
							[resultData]="item.resultData"
							[imgSrc]="item.resultImg"
							[color]="item.color"
							[isOpen]="!!item.opened"
							[isRowItem]="true"
							(opened)="playClick();"
						/>
					}

				}
      </div>
    </div>

    <div class="h-[64px] flex items-center">
      @if (cardOpened) {
        <app-button (clicked)="saveResult();finish()">
          Продолжить
        </app-button>
      } @else if (selected) {
        <app-comment>Нажми на карту, чтобы узнать больше</app-comment>
			} @else {
        <app-comment>Выбери свой вариант</app-comment>
      }
    </div>
  </div>
</app-backgrop>
	<!-- <app-row-cards 
		[cards]="cards"
	/> -->
}
